import type {ReactElement} from 'react';
import React from 'react';
import {SkeletonBrick, SkeletonBrickTheme} from '@Components/skeleton-brick';
import {NavRightSideSkeletonSize} from '@Components/poster-editor/components/poster-editor-nav-bar/components/nav-right-options-skeleton/nav-right-options-skeleton.types';
import styles from './nav-right-options-skeleton.module.scss';

interface NavRightOptionsSkeletonProps {
  size?: NavRightSideSkeletonSize;
}

export function NavRightOptionsSkeleton({size = NavRightSideSkeletonSize.LARGE}: NavRightOptionsSkeletonProps): ReactElement<any> {
  return (
    <>
      <div className={`${styles.skeletonContainer} spacing-m-r-2`}>
        <SkeletonBrick theme={SkeletonBrickTheme.DARK} width={20} height={20} />
      </div>
      <div className={`${styles.skeletonContainer} spacing-m-r-2`}>
        {size === NavRightSideSkeletonSize.LARGE ? (
          <SkeletonBrick theme={SkeletonBrickTheme.DARK} width={76} height={20} />
        ) : (
          <SkeletonBrick theme={SkeletonBrickTheme.DARK} width={20} height={20} />
        )}
      </div>
      {size === NavRightSideSkeletonSize.SMALL ? (
        <SkeletonBrick theme={SkeletonBrickTheme.DARK} width={40} height={40} />
      ) : (
        <>
          <div className="spacing-m-r-2">
            <SkeletonBrick theme={SkeletonBrickTheme.DARK} width={128} height={40} />
          </div>
          <div className="spacing-m-r-2">
            <SkeletonBrick theme={SkeletonBrickTheme.DARK} width={121} height={40} />
          </div>
          <div className="spacing-m-r-2">
            <SkeletonBrick theme={SkeletonBrickTheme.DARK} width={100} height={40} />
          </div>
        </>
      )}
    </>
  );
}
